var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26172 2.86646C5.39573 2.86646 2.26172 6.00046 2.26172 9.86646C2.26172 13.7324 5.39573 16.8665 9.26172 16.8665C11.1477 16.8665 12.8594 16.1206 14.1181 14.9078C14.1444 14.8736 14.1733 14.8407 14.2046 14.8093C14.236 14.778 14.2689 14.7492 14.3031 14.7228C15.5159 13.4641 16.2617 11.7524 16.2617 9.86646C16.2617 6.00046 13.1277 2.86646 9.26172 2.86646ZM16.2936 15.4841C17.5252 13.9445 18.2617 11.9915 18.2617 9.86646C18.2617 4.89589 14.2323 0.866455 9.26172 0.866455C4.29116 0.866455 0.261719 4.89589 0.261719 9.86646C0.261719 14.837 4.29116 18.8665 9.26172 18.8665C11.3867 18.8665 13.3397 18.13 14.8794 16.8984L18.5546 20.5736C18.9451 20.9641 19.5783 20.9641 19.9688 20.5736C20.3594 20.183 20.3594 19.5499 19.9688 19.1593L16.2936 15.4841Z",
    fill: "#706F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.a4fcdded9011cb88c0b9bcd9448667da.svg";
export { ForwardRef as ReactComponent };